import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTopSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChevronTopSmall"><Path d="M8 14L12 10L16 14" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconChevronTopSmall;
